import React from 'react';
import { formStyles } from '../utils/formStyles';
import { useTranslation } from 'react-i18next';

export function SeriesFormFields({ formData, handleChange, handleSubmit, isEdit = false, onCancel }) {
  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="relative">
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className={formStyles.input}
          required
        />
        <label htmlFor="name" className={`${formStyles.label} ${formData.name ? formStyles.labelActive : ''}`}>
          {t('seriesform.name')}
        </label>
      </div>
      
      <div className="relative">
        <textarea
          id="description_de"
          name="description_de"
          value={formData.description_de || ''}
          onChange={handleChange}
          className={`${formStyles.input} min-h-[100px] resize-y`}
          rows="4"
        />
        <label htmlFor="description_de" className={`${formStyles.label} ${formData.description_de ? formStyles.labelActive : ''}`}>
          {t('seriesform.description_de')}
        </label>
      </div>
      
      <div className="relative">
        <textarea
          id="description_en"
          name="description_en"
          value={formData.description_en || ''}
          onChange={handleChange}
          className={`${formStyles.input} min-h-[100px] resize-y`}
          rows="4"
        />
        <label htmlFor="description_en" className={`${formStyles.label} ${formData.description_en ? formStyles.labelActive : ''}`}>
          {t('seriesform.description_en')}
        </label>
      </div>
      <div className="flex justify-end gap-4">
        <button type="submit" className={formStyles.button}>
          {isEdit ? t('seriesform.update') : t('seriesform.create')}
        </button>
        {isEdit && onCancel && (
          <button type="button" onClick={onCancel} className="px-4 py-2 bg-gray-300 dark:bg-zinc-700 rounded text-gray-800 dark:text-gray-200">
            {t('seriesform.cancel')}
          </button>
        )}
      </div>
    </form>
  );
}